import React, { Suspense, useContext, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUpdateLocalTONToCurrenciesRate } from '@Utils/currencies';
import { ViewerContext } from '@Global/store';
import { AppContext } from '@Global/store/appContext';
import { useAppViewer } from '@Apollo/query/getAppViewer/useAppViewer';
import { Preview } from '@Content/pages/preview/index.jsx';
import { useAddBeforeUnloadPromptEffect } from '@Hooks/useAddBeforeUnloadPromptEffect';
import { useParseStartParamDataEffect } from '@Hooks/useParseStartParamDataEffect';
import './styles/toast.css';

const Content = React.lazy(() => import('./content'));

/** контент entry point */
export const App = () => {
  const { appEnv } = useContext(AppContext);
  const viewerCtx = useContext(ViewerContext);
  const { loading, data } = useAppViewer();
  const isPredictionsRoute = window.location.pathname.endsWith('/predictions');

  useEffect(() => {
    (window as any)?.Telegram?.WebApp?.MainButton?.hide();
    if (appEnv === 'telegram') {
      // Initialize Telegram Analytics SDK
      (window as any).telegramAnalytics?.init({
        token:
          'eyJhcHBfbmFtZSI6IkZhbnRvbiIsImFwcF91cmwiOiJodHRwczovL2FwcC5mYW4tdG9uLmNvbSIsImFwcF9kb21haW4iOiJodHRwczovL2FwcC5mYW4tdG9uLmNvbSJ9!rOVjqPRfjkfLPFwEoJ9aGZg0f/GaLTl3tXjC4fMrFKo=',
        appName: 'Fanton',
      });
    }
  }, []);

  useParseStartParamDataEffect();
  useUpdateLocalTONToCurrenciesRate();
  useAddBeforeUnloadPromptEffect();

  return (
    <div className="wrapper">
      <Suspense fallback={appEnv === 'neocrypto' ? null : <Preview />}>
        {isPredictionsRoute || (!loading && data) ? <Content key={viewerCtx.key} /> : null}
      </Suspense>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};
